module.exports = __webpack_public_path__ + "img/Flag_of_Peru.6227fa63.svg";